export default __webpack_public_path__ + "static/media/i245sp.11c03879.webp";